export default "__VITE_ASSET__33b655a7__"